import { render, staticRenderFns } from "./Guidebook.vue?vue&type=template&id=63bb1754&scoped=true&"
import script from "./Guidebook.vue?vue&type=script&lang=js&"
export * from "./Guidebook.vue?vue&type=script&lang=js&"
import style0 from "./Guidebook.vue?vue&type=style&index=0&id=63bb1754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb1754",
  null
  
)

export default component.exports